"use client";

import { Plus } from "lucide-react";
import { useState } from "react";

export interface FaqEntry {
  question: string;
  answer: string;
}

/**
 * Answers stay in the DOM while collapsed so the FAQ is crawlable, which is the
 * whole reason a marketing page carries one.
 */
export function FaqAccordion({ items }: { items: FaqEntry[] }) {
  const [openQuestion, setOpenQuestion] = useState<string | null>(
    items[0]?.question ?? null,
  );

  return (
    <div className="flex flex-col">
      {items.map((item, index) => {
        const isOpen = openQuestion === item.question;
        return (
          <div
            key={item.question}
            className={`border-marketing-border-light border-b ${index === 0 ? "border-t" : ""}`}
          >
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={() => {
                setOpenQuestion(isOpen ? null : item.question);
              }}
              className="flex w-full items-center justify-between gap-6 py-5 text-left transition-opacity hover:opacity-80"
            >
              <span className="text-marketing-text text-[16px] leading-[1.35] font-semibold tracking-[-0.015em] sm:text-[17px]">
                {item.question}
              </span>
              <span
                className={`text-marketing-text-muted flex h-7 w-7 shrink-0 items-center justify-center transition-transform duration-200 ${isOpen ? "text-marketing-text rotate-45" : ""}`}
              >
                <Plus className="h-3.5 w-3.5" strokeWidth={2.2} />
              </span>
            </button>
            <div
              className={`grid transition-[grid-template-rows,padding-bottom,opacity] duration-300 ${
                isOpen
                  ? "grid-rows-[1fr] pb-6 opacity-100"
                  : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="text-marketing-text-muted max-w-[620px] text-[14.5px] leading-[1.6] sm:text-[15px]">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
